// Юридический документ поверх текущего экрана, без ухода с него.
//
// HEAL-69 требует: «ссылки открываются в новой вкладке, без потери введённых данных».
// Буквально новую вкладку открыть нельзя — в нативной сборке страница живёт по схеме
// capacitor://localhost, системный браузер такой адрес не понимает, и документ не
// открывается вовсе (на этом уже обожглись на экране согласий, см. Consent.tsx).
// Уход на /legal/* внутренней навигацией размонтирует форму регистрации и стирает
// введённые фамилию, имя, email и пароль — то самое, что тикет запрещает терять.
//
// Поэтому лист поверх экрана: форма остаётся смонтированной, данные на месте, закрытие
// возвращает ровно туда же. Текст — тот же LegalDocBody, что и на странице /legal/*.

import { X } from 'lucide-react';
import { BottomSheet } from '@/components/ui/bottom-sheet';
import { legalDocs, type LegalKind } from '@/content/legal';
import { LegalDocBody } from './LegalDocBody';

export function LegalSheet({ kind, onClose }: { kind: LegalKind | null; onClose: () => void }) {
  const doc = kind ? legalDocs[kind] : null;

  return (
    <BottomSheet open={kind !== null} onClose={onClose} ariaLabel={doc?.title ?? 'Документ'}>
      {doc && (
        <>
          <div className="sticky top-0 z-10 flex items-center justify-between gap-3 border-b border-border bg-surface px-6 py-3">
            <span className="truncate text-sm font-semibold">{doc.title}</span>
            <button
              type="button"
              onClick={onClose}
              // Не просто «Закрыть»: у листа уже есть кнопка-подложка с этим именем.
              aria-label="Закрыть документ"
              className="-mr-2 flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:bg-muted"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="px-6 pb-10 pt-4">
            <LegalDocBody doc={doc} />
          </div>
        </>
      )}
    </BottomSheet>
  );
}
